import React from 'react';

var ChevronRightIcon = function ChevronRightIcon() {
  return React.createElement("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M12.75 25.5L21.25 17L12.75 8.5",
    stroke: "#3E3E3E",
    "stroke-linejoin": "round"
  }));
};

export default ChevronRightIcon;